export default "__VITE_ASSET__CvmoXf1b__"